//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/TransientObject.js";
import "../no/SectionElementData.js";
import "../no/SelectionIntentRule.js";
let d=[[],[[[],"Dispose",{},0,0],[[],"GetStartConnector",{R_:{start_connector:"NXObject"}},0,0],[[],"GetEndConnector",{R_:{end_connector:"NXObject"}},0,0],[["num_rules","rules"],"GetRules",{},0,0],[["num_section_elements","section_elements_data"],"GetSectionElementsData",{},0,0]],[]];
SPLM.SectionData = class extends SPLM.TransientObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.SectionData";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;